
//职位名称  职位级别
const columnList: Array<column> = [
    {
        prop: "role_name",
        label: "角色权限名称",
        width: 300,
    },
    {
        prop: "text",
        label: "角色权限级别",
        width: 300,
    },
];

import {
    defineComponent,
    ref,
    reactive,
    inject,
    provide,
    onMounted,
    watch,
    getCurrentInstance,
} from "vue";
import { useRoute, useRouter } from "vue-router";
import { getframeworkRoleList } from "@/api/http";
import { column } from "@/assets/types/common";

export default defineComponent({
    name: "FrameworkRole",
    setup() {
        const setTitle: any = inject("setTitle");
        setTitle(["角色权限管理"]);
        let pageSize = ref(10),
            currentPage = ref(1),
            storeId = ref(0),
            total = ref(0),
            tableData = ref([] as Array<any>),
            loading = ref(true),
            headClass = inject("headClass"),
            Router = useRouter(),
            screenParameter: any = {
				store_id:0,
                page: currentPage.value,
                pagesize: pageSize.value,
            },
            addRole = (): void => {
				let query = {};
				if(storeId.value > 0){
					query = {
					  store_id: storeId.value,
					}
				}
				Router.push({
					path:'/framework/jurisdiction',
					query
				});
            },
            editRole = (id:number): void => {
				let query = {};
				if(storeId.value > 0){
					query = {
						id,
						store_id: storeId.value,
					}
				}else{
					query = {
						id
					};
				}
				Router.push({
					path:'/framework/jurisdiction',
					query
				});
            },
            handleSizeChange = (size: number): void => {
                pageSize.value = size;
                screenParameter['pagesize'] = size;
                getTableData();
            },
            handleCurrentChange = (page: number): void => {
                currentPage.value = page;
                screenParameter['page'] = page;
                getTableData();
            },
            getTableData = (): void => {
                loading.value = true;
                getframeworkRoleList(screenParameter).then((res: any) => {
                    tableData.value = res?.content?.list || [];
                    loading.value = false;
                    total.value = res?.content?.total || 0;
                });
            };

        onMounted(() => {
			console.log()
            storeId.value = Number(useRoute().query.store_id);
			console.log(storeId.value)
            screenParameter["store_id"] = useRoute().query.store_id;
            getTableData();
        });

        return {
            columnList,
            tableData,
            storeId,
            loading,
            headClass,
            screenParameter,
            handleSizeChange,
            handleCurrentChange,
            Router,
            pageSize,
            currentPage,
            total,
			addRole,
			editRole
        };
    },
});
